import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProfileApiService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) { }

  getUserById(id: number | string): Observable<any> {
    return this.http.get(`${this.apiUrl}user/profile-details-by-user-id/${id}`);
  }
  updateUserProfile(id: number | string, data: any): Observable<any> {
    return this.http.post(`${this.apiUrl}user/update/${id}`, data);
  }
  getUserAddressById(id: number | string): Observable<any> {
    return this.http.get(`${this.apiUrl}user/address/get-by-user-id/${id}`);
  }

  saveUserAddress(data: any): Observable<any> {
    return this.http.post(`${this.apiUrl}user/create/address`, data);
  }

  createClientGuardian(data: any): Observable<any> {
    return this.http.post(`${this.apiUrl}client-guardians/create`, data);
  }

  getClientGuardianByClientId(clientId: number | string): Observable<any> {
    return this.http.get(`${this.apiUrl}client-guardians/${clientId}`);
  }

  updateClientGuardianByClientId(clientId: number | string, data: any): Observable<any> {
    return this.http.put(`${this.apiUrl}client-guardians/update/${clientId}`, data);
  }

  getEducationByUserId(userId: number | string): Observable<any> {
    return this.http.get(`${this.apiUrl}user/education/get-by-user-id/${userId}`);
  }

  createUserEducation(data: any): Observable<any> {
    return this.http.post(`${this.apiUrl}user/create/education`, data);
  }

  getCoCurricularByUserId(userId: number | string): Observable<any> {
    return this.http.get(`${this.apiUrl}user/co-curricular/get-by-user-id/${userId}`);
  }

  createUserCoCurricular(data: any): Observable<any> {
    return this.http.post(`${this.apiUrl}user/create/co-curricular`, data);
  }

  getWorkExperienceByUserId(userId: number | string): Observable<any> {
    return this.http.get(`${this.apiUrl}user/experience/get-by-user-id/${userId}`);
  }

  createUserWorkExperience(data: any): Observable<any> {
    return this.http.post(`${this.apiUrl}user/create/work-experience`, data);
  }

  changePassword(data: any): Observable<any> {
    return this.http.post(`${this.apiUrl}change-password`, data);
  }
}
  


 
